module.exports = __webpack_public_path__ + "static/media/Click2-Sebastian-759472264.200de8e8.mp3";